import type { CarrierShipmentEvent } from '@/lib/api/carrier-shipment-api'

import { carrierEventLabel } from '@/lib/carrier-status'
import { formatDateTimeShort } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

/** Phần của một lần hãng báo trạng thái mà timeline cần. */
export type CarrierTimelineEvent = Pick<
    CarrierShipmentEvent,
    'id' | 'carrier_status_code' | 'note' | 'event_at'
> & {
    /** Bưu cục lúc báo trạng thái, khi hãng gửi kèm. */
    location?: string | null
}

interface Props {
    events: CarrierTimelineEvent[]
    /** Mặc định danh sách cũ nhất trước (như API chi tiết đơn trả). */
    order?: 'oldest-first' | 'newest-first'
    /** Ẩn tiêu đề khi khung bọc ngoài đã có tiêu đề riêng. */
    hideTitle?: boolean
}

export function CarrierTrackingTimeline({
    events,
    order = 'oldest-first',
    hideTitle = false,
}: Props) {
    const newestFirst =
        order === 'newest-first' ? events : [...events].reverse()
    return (
        <div className="space-y-1">
            {!hideTitle && (
                <p className="text-sm font-medium">
                    {m.carrier_timeline_title()}
                </p>
            )}
            {newestFirst.length === 0 ? (
                <p className="text-muted-foreground text-sm">
                    {m.carrier_timeline_empty()}
                </p>
            ) : (
                <ol className="space-y-1">
                    {newestFirst.map((event) => (
                        <li
                            key={event.id}
                            data-testid="carrier-event"
                            className="border-border flex flex-wrap gap-x-2 border-l-2 pl-2 text-sm"
                        >
                            <span className="font-medium">
                                {carrierEventLabel(event.carrier_status_code)}
                            </span>
                            <span className="text-muted-foreground text-xs">
                                {formatDateTimeShort(event.event_at)}
                                {event.location && ` · ${event.location}`}
                            </span>
                            {event.note && (
                                <span className="text-muted-foreground w-full text-xs">
                                    {event.note}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </div>
    )
}
